import { mapCurrency } from '@webapp/core/data-access/mappers/mapCurrency'
import { ExternalBankAccountTypes } from '../../entities/enums/ExternalBankAccountTypeEnum'
import { type ExternalBankAccountConstructor } from '../../entities/ExternalBankAccount'
import { type ExternalBankAccountApiModel } from '../api-models/ExternalBankAccountApiModel'

export const mapExternalBankAccountApiModel = (
  data: ExternalBankAccountApiModel
): ExternalBankAccountConstructor => {
  const baseData = {
    id: data.id,
    name: data.name,
    currency: mapCurrency(data.currency),
    glCode: data.gl_code,
  }

  switch (data.type) {
    case ExternalBankAccountTypes.CHECK:
      return {
        ...baseData,
        type: ExternalBankAccountTypes.CHECK,
        data: {
          startNumber: data.data.start_number ?? '',
        },
      }

    case ExternalBankAccountTypes.ACH:
      return {
        ...baseData,
        type: ExternalBankAccountTypes.ACH,
        data: {
          bankName: data.data.bank_name ?? '',
          bankRoutingNumber: data.data.bank_routing_number ?? '',
          companyName: data.data.company_name ?? '',
          companyRoutingNumber: data.data.company_routing_number ?? '',
          companyTaxId: data.data.company_tax_id ?? '',
        },
      }

    case ExternalBankAccountTypes.EFT:
      return {
        ...baseData,
        type: ExternalBankAccountTypes.EFT,
        data: {
          description: data.data.description,
        },
      }

    case ExternalBankAccountTypes.WIRE:
      return {
        ...baseData,
        type: ExternalBankAccountTypes.WIRE,
        data: {
          description: data.data.description,
        },
      }

    case ExternalBankAccountTypes.OTHER:
    default:
      return {
        ...baseData,
        type: ExternalBankAccountTypes.OTHER,
        data: {
          description: data.data.description,
        },
      }
  }
}
